module.exports = __webpack_public_path__ + "static/media/bg_img.28684d40.webp";